import { useState } from "react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { AttachmentChannelPicker } from "./AttachmentChannelPicker";

/** Por onde mais os arquivos do pedido foram enviados (iTero, 3Shape, WhatsApp...) — editável dos
 *  dois lados (clínica ou laboratório, ver prosthesis.setSentChannels). O escaneamento muitas vezes
 *  vai pelo sistema do scanner, e o laboratório precisa saber onde procurar.
 *
 *  Lido como texto ("WhatsApp, iTero") e editado só no "Alterar": os chips sempre à vista tinham o
 *  mesmo formato das pílulas de status e ninguém sabia se eram botão ou informação. `readOnly`
 *  (ex: resumo do Início) tira o "Alterar". */
export function SentChannelsField({
  orderId,
  sentChannels,
  readOnly = false,
}: {
  orderId: string;
  sentChannels: string[];
  readOnly?: boolean;
}) {
  const utils = trpc.useUtils();
  const [editando, setEditando] = useState(false);

  const setSentChannels = trpc.prosthesis.setSentChannels.useMutation({
    onSuccess: () => {
      utils.prosthesis.getById.invalidate({ id: orderId });
      utils.prosthesis.incoming.getById.invalidate({ id: orderId });
      utils.prosthesis.incoming.list.invalidate();
    },
    onError: (err) => toast.error(err.message || "Erro ao atualizar."),
  });

  if (editando) {
    return (
      <div className="rounded-lg border border-zinc-200 p-3 dark:border-border">
        <p className="mb-2 text-xs font-medium text-zinc-600 dark:text-muted-foreground">Por onde mais os arquivos deste pedido foram enviados?</p>
        <AttachmentChannelPicker value={sentChannels} onChange={(channels) => setSentChannels.mutate({ orderId, sentChannels: channels })} />
        <div className="mt-2 flex justify-end">
          <button
            type="button"
            onClick={() => setEditando(false)}
            className="h-8 rounded-md border border-zinc-200 px-3 text-xs font-semibold text-zinc-700 hover:bg-zinc-50 dark:border-border dark:text-foreground dark:hover:bg-muted"
          >
            Pronto
          </button>
        </div>
      </div>
    );
  }

  return (
    <p className="text-[13px] text-zinc-700 dark:text-foreground/80">
      <span className="text-zinc-500 dark:text-muted-foreground">Arquivos também enviados por: </span>
      {sentChannels.length ? sentChannels.join(", ") : <span className="text-zinc-400 dark:text-muted-foreground/70">nenhum outro canal</span>}
      {!readOnly && (
        <button
          type="button"
          onClick={() => setEditando(true)}
          className="ml-2 text-xs font-semibold text-brand-700 hover:underline dark:text-primary"
        >
          Alterar
        </button>
      )}
    </p>
  );
}
